import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'
import * as Sentry from '@sentry/browser'
import { withRouter } from 'react-router-dom'
import auth from '../../auth'

import {
  Main
} from '../../containers'

import {
  Spinner,
  GlobalNavigation
} from '../'

import {
  decodeBase64
} from '../../utils'

const setUserResponsibilities = (userResponsibilities) => {
  if (!localStorage.hasOwnProperty('userResponsibilities')) {
    // save user responsibilities
    localStorage.setItem('userResponsibilities', JSON.stringify(userResponsibilities.edges))
  }
}

const setIdentityResponsibilities = (identityResponsibilities) => {
  if (!localStorage.hasOwnProperty('identityResponsibilities')) {
    // save identity responsibilities
    localStorage.setItem('identityResponsibilities', JSON.stringify(identityResponsibilities.edges))
  }
}

class Application extends React.Component {
  state = {
    identityInitialised: false
    // necessity of this state variable and localStorage usage below to possibly be replaced with context api
  }

  shouldComponentUpdate(nextProps, nextState) {
    let currentLocation = this.props.location
    let nextLocation = nextProps.location

    if (this.props.data.me && nextProps.data.me &&
      currentLocation.pathname === nextLocation.pathname &&
      currentLocation.search === nextLocation.search &&
      this.state.identityInitialised) {
      return false
    }

    return true
  }

  componentDidUpdate(prevProps, prevState) {
    if (auth.loggedIn() && !this.state.identityInitialised && this.props.data && this.props.data.me) {
      let userIdentity = this.props.data.me
      if (!localStorage.hasOwnProperty('isUserPicsaEmployee')) {
        localStorage.setItem('isUserPicsaEmployee', userIdentity.employee !== null && userIdentity.employee.status === 'ACTIVE')
      }
      if (!localStorage.hasOwnProperty('userDecodedID')) {
        let userEmailAddress = userIdentity.defaultEmailAddress.edges.length > 0
          ? userIdentity.defaultEmailAddress.edges[0].node.addressValue
          : null
        // save user details
        localStorage.setItem('userDecodedID', decodeBase64(userIdentity.id))
        localStorage.setItem('userUUID', userIdentity.id)
        localStorage.setItem('userEmailAddress', userEmailAddress)

        if (userIdentity.contacts.edges.length > 0) {
          localStorage.setItem('employer', userIdentity.contacts.edges[0].node.employer.id)
        }
        // set user related responsibilities
        setUserResponsibilities(userIdentity.responsibilities)
        setIdentityResponsibilities(userIdentity.identityResponsibilities)

        if (process.env.NODE_ENV === 'production') {
          Sentry.configureScope(scope => {
            scope.setUser({
              "id": userIdentity.id,
              "email": userEmailAddress
            })
          })
        }
      }

      this.setState({ identityInitialised: true })
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    }

    // don't error if they've not logged in yet
    if (this.props.data.error && auth.loggedIn()) {
      return <h1>Oh dear! We have an issue</h1>
    }

    return (
      <div>
        <GlobalNavigation />
        <Main />
      </div>
    )
  }
}

const getUser = gql`
  query {
    me {
      ...MyInfo
      defaultEmailAddress: addresses(addressType: "email", default: true) {
        edges {
          node {
            id
            addressValue
          }
        }
      }
      responsibilities {
        edges {
          node {
            id
            description
            relatedModel
            relatedId
          }
        }
      }
      identityResponsibilities {
        edges {
          node {
            id
            responsibilitytype {
              id
            	name
            }
            relatedId
            relatedModel {
              id
              model
            }
          }
        }
      }
    }
  }
  ${fragments.me}
`

const withData = graphql(getUser)

export default compose(
  withData,
  withRouter
)(Application)



// WEBPACK FOOTER //
// ./src/components/application/index.js